/**
 * TopNavbarComponent
 * ------------------
 * Ova komponenta prikazuje gornju navigacijsku traku aplikacije.
 * Služi za navigaciju između različitih dijelova aplikacije.
 */
import { Component } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {TranslateService} from "@ngx-translate/core";
import { AuthService } from '../../service/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-top-navbar',
  imports: [CommonModule, RouterLink],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.css'
})
export class TopNavbarComponent {
  user$: Observable<any | null>;

  constructor(private translate: TranslateService, public router: Router, public authService: AuthService) {
    this.translate.addLangs(['hr', 'en']);
    this.translate.setDefaultLang('hr');
    this.translate.use('hr');
    this.translate.use(this.translate.getBrowserLang() || "en");
    this.user$ = this.authService.currentUser;
  }

  useLanguage(language: string): void {
    this.translate.use(language);
}

}
